import { useTranslation } from 'react-i18next';
import SiteNavbar from '@/components/feature/SiteNavbar';
import SiteFooter from '@/components/feature/SiteFooter';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroBlock from './components/HeroBlock';
import FeaturesBlock from './components/FeaturesBlock';
import NotifyBlock from './components/NotifyBlock';

export default function KozmikGunlukPage() {
  const { t } = useTranslation();
  const links = [
    { label: 'nav.home',        href: '/',        isRoute: true },
    { label: 'nav.apps',        href: '/apps',    isRoute: true },
    { label: 'nav.games',       href: '/games',   isRoute: true },
    { label: 'nav.notify',      href: '/?contactProduct=kozmik-gunluk#contact', isRoute: true },
  ];

  return (
    <div className="min-h-screen bg-[#0c0c0c]">
      <SiteNavbar links={links} sectionAware={false} />
      <HeroBlock />
      <FeaturesBlock />
      <NotifyBlock />
      <SiteFooter />
      <ScrollToTop />
    </div>
  );
}
